import {
  Heading,
  Text,
  ListItem,
  UnorderedList,
  VStack,
} from "@chakra-ui/react";

import { Paper } from "#app/components/index.jsx";
import { getSeoMeta, getBaseUrl, getDefaultOgImage } from "#app/utils/meta.js";

export function meta({ matches }) {
  const baseUrl = getBaseUrl(matches);
  return getSeoMeta({
    title: "Affiliate Agreement | Schnerp",
    description:
      "Terms and conditions for the Schnerp affiliate referral program.",
    url: `${baseUrl}/legal/affiliate`,
    image: getDefaultOgImage(baseUrl),
  });
}

export default function AffiliateProgram() {
  return (
    <VStack as={Paper} align="left" spacing={6} m={4}>
      <Heading as="h1" size="sm">
        Terms of Service for Affiliate Program
      </Heading>
      <Text>Last updated: September 28, 2026</Text>
      <Text>
        There are a few rules about our affiliate program you should know about.
        No “gotchas” here, just some terms to keep everyone happy.
      </Text>
      <UnorderedList pl={8} spacing={2}>
        <ListItem>
          Self-referrals are not allowed (i.e. signing up for Rewardful through
          your own affiliate link)
        </ListItem>
        <ListItem>
          Abuse, gaming, or attempting to mislead (i.e. posting fake discounts
          to coupon-sharing websites) will result in your account being
          permanently banned.
        </ListItem>
        <ListItem>
          In some cases, we can give credit to an affiliate even if the customer
          didn’t sign up through an affiliate link or coupon code. If you have a
          case like this, please contact us and we’ll do our best to help.
        </ListItem>
        <ListItem>
          No search engine ads (especially on branded terms or domain names),
          Facebook ads or other ads that would compete with our own marketing
          and cause potential confusion for customers.
        </ListItem>
        <ListItem>
          No Facebook ads that link to our website or anything similar that
          would compete with our own paid marketing and drive up our costs and
          potentially cause confusion.
        </ListItem>
        <ListItem>
          No pretending to be acting on behalf of us (ie. as an employee).
        </ListItem>
        <ListItem>
          We reserve the right to change the Terms of Service for our affiliate
          program at any time.
        </ListItem>
        <ListItem>
          We reserve the right to terminate your affiliate account for violation
          of any of the rules at our sole discretion. Commissions generated by
          mechanisms that are in violation of our Terms of Service will not be
          paid or owed.
        </ListItem>
      </UnorderedList>
      <Heading size="xs">Commission</Heading>
      <Text>
        Affiliates earn 25% of every payment a referred customer makes within
        the first 12 months of their paid subscription. The 12 months start at
        the customer&apos;s first paid payment, not when they begin a free
        trial. Payments made after the first 12 months are not eligible for
        commission.
      </Text>
      <Heading size="xs">Referral tracking</Heading>
      <Text>
        A customer is tracked as your referral when they click your referral
        link or use your coupon code and then start a free trial within 30 days.
        They can subscribe to a paid plan at any time after that and still count
        as your referral.
      </Text>
      <Heading size="xs">Referral discount</Heading>
      <Text>
        Customers who sign up through your referral link or coupon code receive
        10% off all of their payments for as long as they remain a member.
      </Text>
      <Heading size="xs">Commission payment</Heading>
      <Text>Rewardful commissions are paid:</Text>
      <UnorderedList pl={8} spacing={2}>
        <ListItem>Monthly (usually on the 1st)</ListItem>
        <ListItem>
          Via PayPal. In order to receive payment, you must provide a valid
          PayPal email address.
        </ListItem>
        <ListItem>With no minimum balance.</ListItem>
      </UnorderedList>
    </VStack>
  );
}
